import { TimelineZoomData } from "../../mock/timeline";
import { Box } from "../Box";
import { FlexContainer } from "../Flex";
import { Text } from "../Text";
import { TimelineScrollZoom } from "./TimelineScrollZoom";
import { TimelineImage } from "./TimlineImage";

interface TimelineItemZoomProps {
  data: TimelineZoomData;
}

export const TimelineItemZoom: React.FC<TimelineItemZoomProps> = ({ data }) => {
  return (
    <Box>
      <TimelineScrollZoom
        x={data.x}
        yFactor={data.yFactor}
        scale={data.scale}
        rotation={data.rotation}
      >
        <TimelineImage
          imageConfig={data.image}
          labelPosition={data.labelPosition}
        >
          <FlexContainer
            justifyContent={
              data.labelAlignment === "start" ? "flex-start" : "flex-end"
            }
            mx={-1}
          >
            <Text variant="small" as="span" fontWeight={700} px={1}>
              {data.yearText}
            </Text>
            <Text variant="small" as="span" px={1}>
              {data.labelText}
            </Text>
          </FlexContainer>
        </TimelineImage>
      </TimelineScrollZoom>
    </Box>
  );
};
